module.exports = __webpack_public_path__ + "static/media/icon-instagram.14fbb71e.svg";